import { render, staticRenderFns } from "./tord_pay_automatic.vue?vue&type=template&id=fee9ee34&scoped=true&"
import script from "./tord_pay_automatic.vue?vue&type=script&lang=js&"
export * from "./tord_pay_automatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee9ee34",
  null
  
)

export default component.exports